import React from "react"
import CountUp from "react-countup"
import VisibilitySensor from "react-visibility-sensor"

const Counter = ({ endPoint }) => (
  <>
    <CountUp useEasing={true} duration={5} end={endPoint} redraw={true}>
      {({ countUpRef, start }) => (
        <VisibilitySensor onChange={start} delayedCall>
          <span
            className="text-5xl font-extrabold text-blue-700"
            ref={countUpRef}
          />
        </VisibilitySensor>
      )}
    </CountUp>
  </>
)

export default Counter
